<div class="question-skip">     
    <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
      <input type="checkbox" name="add-note-toggle" id="skip-toggle">
      <span class="custom-toggle__indi"></span>
      <span class="custom-toggle__label">Skip for now</span>
    </label>
</div>
<div id="skip-section">
  <div class="question-pull">
    <div class="card card--freeform">
      <div class="card-body">
        <div class="card__content">
          <div class="form-group mt-10 mt-md-15">
            <label>Was this item damaged, lost or stolen?</label>
            <div class="custom-input--icon-lg__flex-container">
              <label
                class="custom-input custom-input--icon-lg"
              >
                <input type="radio" name="radio-example-1" />
                <span class="custom-input__label">
                  <img src="assets/icn/class/lg-fire.svg" class="icon">
                  <h5 class="font-16">Damaged</h5>
                </span>
              </label>
              <label
                class="custom-input custom-input--icon-lg"
              >
                <input type="radio" name="radio-example-1" />
                <span class="custom-input__label">
                  <img src="assets/icn/class/lg-fire.svg" class="icon">
                  <h5 class="font-16">Lost</h5>
                </span>
              </label>
              <label
                class="custom-input custom-input--icon-lg"
              >
                <input type="radio" name="radio-example-1" />
                <span class="custom-input__label">
                  <img src="assets/icn/class/lg-fire.svg" class="icon">
                  <h5 class="font-16">Stolen</h5>
                </span>
              </label>
            </div>
          </div>
          <div class="form-group">
            <label>Upload proof of ownership</label>
            <div class="note note--sm note--info mb-15">
              <div class="note__icon">
                <svg class="icon"><use xlink:href="#info-small"></use></svg>
              </div>
              <div class="note__content">
                <p>Note on what to take images of lorem ipsum dolor sit amet.</p>
              </div>
            </div>
            <div class="custom-upload custom-upload--media" id="upload">
              <div class="custom-upload__dropzone dz-default">
                <div class="custom-upload__thumb">
                  <img src="assets/img/upload-image.svg" />
                </div>
                <div class="custom-upload__instructions">
                    <p>Tap to add files</p>
                    <svg class="icon"><use xlink:href="#upload"></use></svg>
                    <p>Drag & drop files here or <strong>browse</strong></p>
                </div>
              </div>
              <div class="fallback">
                <input type="file" name="file" multiple />
              </div>
            </div>
          </div>
          <div class="card__tray">
            <div class="card__actions">
              <a href="#" class="text-link">Clear</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /card -->
    <!-- /.question-pull -->
  </div>
</div>